import { render, staticRenderFns } from "./MainBusiness.vue?vue&type=template&id=cc563974&scoped=true"
import script from "./MainBusiness.vue?vue&type=script&lang=js"
export * from "./MainBusiness.vue?vue&type=script&lang=js"
import style0 from "./MainBusiness.vue?vue&type=style&index=0&id=cc563974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc563974",
  null
  
)

export default component.exports